module.exports = __webpack_public_path__ + "static/media/map-marked.45c01d66.svg";